(function ($) {
    'use strict';

    window.init_triggers = function() {
        var TOGGLE_DISABLED_ELEMENT_SELECTOR = '.js-toggle-disabled';
        var TOGGLE_HIDDEN_ELEMENT_SELECTOR = '.js-toggle-hidden';

        var CHECKBOX_GROUP_SELECTOR = '.js-checkbox-group';
        var CHECKBOX_GROUP_HEAD_SELECTOR = '.category_head';
        var CHECKBOX_GROUP_MEMBER_SELECTOR = '.category_member';

        $(TOGGLE_DISABLED_ELEMENT_SELECTOR).each(function(){
            var targetId = '#' + $(this).data("target-enable");

            if ($(this).is(':checked')) {
                $(targetId).prop( "disabled", false);
            }
            else {
                $(targetId).prop( "disabled", true);
            }
            $(this).change(function() {
                if ($(this).is(':checked')) {
                    $(targetId).prop( "disabled", false);
                }
                else {
                    $(targetId).prop( "disabled", true);
                }
            });
        });

        $(TOGGLE_HIDDEN_ELEMENT_SELECTOR).each(function(){
            var targetId = '#' + $(this).data("target-show");

            if ($(this).is(':checked')) {
                $(targetId).show( );
            }
            else {
                $(targetId).hide();
            }
            $(this).change(function() {
                if ($(this).is(':checked')) {
                    $(targetId).show();
                }
                else {
                    $(targetId).hide();
                }
            });

        });

        $(CHECKBOX_GROUP_SELECTOR).each(function(){
            var $checkboxGroup = $(this);
            var $checkboxHeadItem = $checkboxGroup.find(CHECKBOX_GROUP_HEAD_SELECTOR);
            var $checkboxItems = $checkboxGroup.find(CHECKBOX_GROUP_MEMBER_SELECTOR);

            $checkboxItems.click(function(){
                $checkboxHeadItem.prop('checked', true);
                $checkboxItems.each(function () {
                    if (!$(this).is(':checked')) {
                        $checkboxHeadItem.prop('checked', false);
                    }
                });
            });

            $checkboxHeadItem.click(function () {
                if ($(this).is(':checked')) {
                    $checkboxItems.each(function () {
                        $(this).prop('checked', true);
                    })
                }
                else {
                    $checkboxItems.each(function () {
                        $(this).prop('checked', false);
                    })
                }
            });
        });
    };
})(jQuery);
